<template>
	<div class="control column">
		<!--<label class="label">Selection</label>-->
		<span class="select">
			<select v-validate="{ rules: { required: true, in: [targetValue] } }"
			        data-vv-name="selection"
			        :class="{'is-danger': errors.has('selection') }"
			>
				<option v-for="op in options">{{op}}</option>
			</select>
		</span>
		<span v-show="errors.has('selection')"
		   class="help is-danger">
			X
		</span>
	</div>
</template>

<script>
	import randSentence from 'random-sentence'
	export default {
		name: 'selection',
		data () {
			return {
				targetValue: '',
				options: []
			}
		},
		created () {
			var count = _.random(2, 7);
			var curIndex = _.random(1,count-1);
			var options = []
//			options.push('Select Me!')
			for (var i=0; i<count; i++) {
				options.push(randSentence({min:1,max:3}))
			}
			this.targetValue = options[curIndex]
			this.options = options
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	select.is-danger {
		border-color: #ff3860;
	}
</style>



// WEBPACK FOOTER //
// Selection.vue?27132538